var Subscribe = function() {

    return {
        init: function() {
            $('#email-input').blur(function() {
                Generic.checkEmail(true, '');
            });
            $('#username-input').blur(function() {
                Generic.checkUsername(true, '');
            });
            if ($('#register_password2')) {
                $('#register_password2').keyup(function() {
                    if ($('#register_password').val() != $('#register_password2').val()) {
                        $('#check_password2').html('Τα passwords δεν ταιριάζουν');
                    } else {
                        $('#check_password2').html('');
                    }
                });
            }
        },
        verify: function() {
            if (!Generic.hasMinChars(document.frm.email, 7)) {
                return false;
            }
            if (!Generic.hasMinChars(document.frm.username, 3)) {
                return false;
            }
            if (!Generic.hasMinChars(document.frm.password, 3)) {
                return false;
            }

            if (!Generic.isEmail(document.frm.email.value)) {
                Generic.showError(document.frm.email, 'Λάθος email');
                return false;
            } else {
                Generic.hideError(document.frm.email);
            }

            if (!Generic.isUsername(document.frm.username.value)) {
                Generic.showError(document.frm.username, 'Επιτρεπόμενοι χαρακτήρες για το username: a-z 0-9 . _ -');
                return false;
            } else {
                Generic.hideError(document.frm.username);
            }

            if (document.frm.password.value != document.frm.password2.value) {
                Generic.showError(document.frm.password2, 'Τα passwords δεν ταιριάζουν');
                return false;
            } else {
                Generic.hideError(document.frm.password2);
            }

            // server checks
            Generic.checkEmail(false, '');
            if ($('#check_email').html().length > 2) {
                Generic.showError(document.frm.email, 'Επιλέξτε άλλο email');
                return false;
            } else {
                Generic.hideError(document.frm.email);
            }

            Generic.checkUsername(false, '');
            if ($('#check_username').html().length > 2) {
                Generic.showError(document.frm.username, 'Επιλέξτε άλλο username');
                return false;
            } else {
                Generic.hideError(document.frm.username);
            }

            if (!$('#optin').is(':checked')) {
                Generic.showError(document.frm.optin, 'Πρέπει να διαβάσετε τους όρους και να κάνετε αποδοχή');
                return false;
            } else {
                Generic.hideError(document.frm.optin);
            }

            return true;
        },
    };
}();
